:root {
  --color-violet-900: #3619ba;
  --color-violet-800: #4437d2;
  --color-violet-700: #5552ec;
  --color-violet-600: #6672ff;
  --color-violet-500: #969eff;
  --color-violet-400: #c0c8ff;
  --color-violet-300: #d9deff;
  --color-violet-200: #e5e9ff;
  --color-violet-100: #f5f6ff;
  --color-forest-900: #005054;
  --color-forest-800: #00666b;
  --color-forest-700: #338589;
  --color-forest-600: #66a3a6;
  --color-forest-500: #8cbabc;
  --color-forest-400: #b2d1d3;
  --color-forest-300: #cce0e1;
  --color-forest-200: #d9e8e9;
  --color-forest-100: #e5f0f0;
  --color-green-900: #00864c;
  --color-green-800: #00b365;
  --color-green-700: #33c284;
  --color-green-600: #66d1a3;
  --color-green-500: #8cddba;
  --color-green-400: #b2e8d1;
  --color-green-300: #ccf0e0;
  --color-green-200: #d9f4e8;
  --color-green-100: #e5f7f0;
  --color-teal-900: #008289;
  --color-teal-800: #00a7b0;
  --color-teal-700: #33b9c0;
  --color-teal-600: #66cad0;
  --color-teal-500: #8cd7db;
  --color-teal-400: #b2e5e7;
  --color-teal-300: #ccedef;
  --color-teal-200: #d9f2f3;
  --color-teal-100: #e5f6f7;
  --color-lobster-900: #ea0b0b;
  --color-lobster-800: #f75251;
  --color-lobster-700: #f97574;
  --color-lobster-600: #fa9797;
  --color-lobster-500: #fbb1b1;
  --color-lobster-400: #fdcbcb;
  --color-lobster-300: #fddcdc;
  --color-lobster-200: #fee5e5;
  --color-lobster-100: #feeeee;
  --color-orange-900: #b95b03;
  --color-orange-800: #e37c30;
  --color-orange-700: #ffab00;
  --color-orange-600: #ffcd66;
  --color-orange-500: #ffd98c;
  --color-orange-400: #ffe6b2;
  // stylelint-disable-next-line color-hex-length
  --color-orange-300: #ffeecc;
  --color-orange-200: #fff2d9;
  --color-orange-100: #fff7e5;
  --color-pink-900: #d73461;
  --color-pink-800: #f9567c;
  --color-pink-700: #ff7393;
  --color-pink-600: #ffabbe;
  --color-pink-500: #ffc0ce;
  --color-pink-400: #ffd5df;
  --color-pink-300: #ffe3e9;
  --color-pink-200: #ffeaef;
  --color-pink-100: #fff1f4;
  --color-grey-800: #1a1a1a;
  --color-grey-700: #535353;
  --color-grey-600: #817f7d;
  --color-grey-500: #aba8a4;
  --color-grey-400: #d7d4d1;
  --color-grey-300: #e5e4e3;
  --color-grey-200: #f2f2f2;
  --color-grey-100: #f9f9f9;
  // stylelint-disable-next-line color-hex-length
  --color-grey-0: #ffffff;
  --color-berry-900: #613b99;
  --color-berry-800: #7550b0;
  --color-berry-700: #9173c0;
  --color-berry-600: #ac96d0;
  --color-berry-500: #baa7d7;
  --color-berry-400: #c8b9df;
  --color-berry-300: #d6cae7;
  --color-berry-200: #e3dcef;
  --color-berry-100: #f1edf7;
  --color-sea-900: #004a86;
  --color-sea-800: #005da9;
  --color-sea-700: #337dba;
  --color-sea-600: #669ecb;
  --color-sea-500: #80aed4;
  --color-sea-400: #99bedd;
  --color-sea-300: #b2cee5;
  --color-sea-200: #ccdfee;
  --color-sea-100: #e5eff6;
  --color-lemon-900: #976e00;
  --color-lemon-800: #d89e00;
  --color-lemon-700: #e0d500;
  --color-lemon-600: #ebe34b;
  --color-lemon-500: #f1eb81;
  --color-lemon-400: #f5f1a5;
  --color-lemon-300: #f9f7c9;
  --color-lemon-200: #fbf9db;
  --color-lemon-100: #fbfae7;
}

// stylelint-disable-next-line selector-pseudo-class-no-unknown
:export {
  /* stylelint-disable property-no-unknown */
  colorViolet900: var(--color-violet-900);
  colorViolet800: var(--color-violet-800);
  colorViolet700: var(--color-violet-700);
  colorViolet600: var(--color-violet-600);
  colorViolet500: var(--color-violet-500);
  colorViolet400: var(--color-violet-400);
  colorViolet300: var(--color-violet-300);
  colorViolet200: var(--color-violet-200);
  colorViolet100: var(--color-violet-100);
  colorForest900: var(--color-forest-900);
  colorForest800: var(--color-forest-800);
  colorForest700: var(--color-forest-700);
  colorForest600: var(--color-forest-600);
  colorForest500: var(--color-forest-500);
  colorForest400: var(--color-forest-400);
  colorForest300: var(--color-forest-300);
  colorForest200: var(--color-forest-200);
  colorForest100: var(--color-forest-100);
  colorGreen900: var(--color-green-900);
  colorGreen800: var(--color-green-800);
  colorGreen700: var(--color-green-700);
  colorGreen600: var(--color-green-600);
  colorGreen500: var(--color-green-500);
  colorGreen400: var(--color-green-400);
  colorGreen300: var(--color-green-300);
  colorGreen200: var(--color-green-200);
  colorGreen100: var(--color-green-100);
  colorTeal900: var(--color-teal-900);
  colorTeal800: var(--color-teal-800);
  colorTeal700: var(--color-teal-700);
  colorTeal600: var(--color-teal-600);
  colorTeal500: var(--color-teal-500);
  colorTeal400: var(--color-teal-400);
  colorTeal300: var(--color-teal-300);
  colorTeal200: var(--color-teal-200);
  colorTeal100: var(--color-teal-100);
  colorLobster900: var(--color-lobster-900);
  colorLobster800: var(--color-lobster-800);
  colorLobster700: var(--color-lobster-700);
  colorLobster600: var(--color-lobster-600);
  colorLobster500: var(--color-lobster-500);
  colorLobster400: var(--color-lobster-400);
  colorLobster300: var(--color-lobster-300);
  colorLobster200: var(--color-lobster-200);
  colorLobster100: var(--color-lobster-100);
  colorOrange900: var(--color-orange-900);
  colorOrange800: var(--color-orange-800);
  colorOrange700: var(--color-orange-700);
  colorOrange600: var(--color-orange-600);
  colorOrange500: var(--color-orange-500);
  colorOrange400: var(--color-orange-400);
  colorOrange300: var(--color-orange-300);
  colorOrange200: var(--color-orange-200);
  colorOrange100: var(--color-orange-100);
  colorPink900: var(--color-pink-900);
  colorPink800: var(--color-pink-800);
  colorPink700: var(--color-pink-700);
  colorPink600: var(--color-pink-600);
  colorPink500: var(--color-pink-500);
  colorPink400: var(--color-pink-400);
  colorPink300: var(--color-pink-300);
  colorPink200: var(--color-pink-200);
  colorPink100: var(--color-pink-100);
  colorGrey800: var(--color-grey-800);
  colorGrey700: var(--color-grey-700);
  colorGrey600: var(--color-grey-600);
  colorGrey500: var(--color-grey-500);
  colorGrey400: var(--color-grey-400);
  colorGrey300: var(--color-grey-300);
  colorGrey200: var(--color-grey-200);
  colorGrey100: var(--color-grey-100);
  colorGrey0: var(--color-grey-0);
  colorBerry900: var(--color-berry-900);
  colorBerry800: var(--color-berry-800);
  colorBerry700: var(--color-berry-700);
  colorBerry600: var(--color-berry-600);
  colorBerry500: var(--color-berry-500);
  colorBerry400: var(--color-berry-400);
  colorBerry300: var(--color-berry-300);
  colorBerry200: var(--color-berry-200);
  colorBerry100: var(--color-berry-100);
  colorSea900: var(--color-sea-900);
  colorSea800: var(--color-sea-800);
  colorSea700: var(--color-sea-700);
  colorSea600: var(--color-sea-600);
  colorSea500: var(--color-sea-500);
  colorSea400: var(--color-sea-400);
  colorSea300: var(--color-sea-300);
  colorSea200: var(--color-sea-200);
  colorSea100: var(--color-sea-100);
  colorLemon900: var(--color-lemon-900);
  colorLemon800: var(--color-lemon-800);
  colorLemon700: var(--color-lemon-700);
  colorLemon600: var(--color-lemon-600);
  colorLemon500: var(--color-lemon-500);
  colorLemon400: var(--color-lemon-400);
  colorLemon300: var(--color-lemon-300);
  colorLemon200: var(--color-lemon-200);
  colorLemon100: var(--color-lemon-100);
  /* stylelint-enable property-no-unknown */
}
